import { AbstractReportPmsApiService } from '../abstract-report.service';
import { ReservationByCountry } from '../../../models/reports/production/reservation-by-country.model';

/**
 * @class ReservationsByCountryReportPmsApiService
 * @extends {AbstractReportPmsApiService<ReservationByCountry>}
 */
export class ReservationsByCountryReportPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/production/reservations-by-country';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {ReservationByCountry}
     * @protected
     */
    newModel(attributes, ...params) {

        return new ReservationByCountry(attributes);
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/production/reservations-by-country-report.service.js